export default __webpack_public_path__ + "static/media/island_2.faf6232c.png";